import React from "react";

interface DetailPageMiniImagesProps {
  images: string[];
  selectedImage: string;
  setSelectedImage: (img: string) => void;
}

const DetailPageMiniImages: React.FC<DetailPageMiniImagesProps> = ({
  images,
  selectedImage,
  setSelectedImage,
}) => {
  return (
    <>
      <div className="display-max">
        <div className="d-flex justify-content-center align-items-center gap-2">
          {images.map((img, index) => (
            <div
              key={index}
              className={`mini-pro-img ${selectedImage === img ? "active-mini" : ""}`}
              onMouseEnter={() => setSelectedImage(img)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={img}
                className="mini-product-img p-1"
                loading="lazy"
                alt=""
                onError={(e) => {
                  e.currentTarget.src = "../../../assets/img/salarlogo.png";
                }}
              />
            </div>
          ))}
        </div>
      </div>
      <div className="display-mini display-mob">
        <div className="py-6 pt-6 bg-gray">
          <div className="d-flex justify-content-start align-items-center overflow-sides">
            {images.map((img, index) => (
              <div className="w-100" key={index} onClick={() => setSelectedImage(img)}>
                <img
                  src={img}
                  alt=""
                  className="mini-detail-images"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = "../../../assets/img/salarlogo.png";
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailPageMiniImages;
